import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../store/api/Users";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const UserProfile = () => {
    const history = useHistory();
    const roleList = JSON.parse(localStorage.getItem("RoleList"));
    const userInfo = JSON.parse( localStorage.getItem("UserInfo"));
    let isLoadingSaved = useSelector(state => state.loading?.isLoading);    
    const translateRole = (roleName) => {
        switch (roleName) {
            case "Reception":
                return "کاربر پذیرش";
            case "Staff":
                return "تکنسین";
            case "Agent":
                return "نماینده";
            default:
                return "";
        }
    }
    const dispatch = useDispatch();
    const save = ()=>{
        let data ={};
        document.querySelectorAll("[userinfo]").forEach(e=>data[e.name] = e.value);
        const onSuccess=()=>{
            if(data.Password !=="")
            {
                localStorage.removeItem("token");
                history.push("/");
            }
        }
        dispatch(updateUser(data, onSuccess));

    }
    useEffect(()=>{
        document.body.classList = "notMain";
    },[]);
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">پروفایل کاربر</div>
                <div className="card-body bodyStyle" style={{textAlign:"right"}}>
                    <div className="row">
                        <div className="form-group col-md-3">
                            <label>نام کامل</label>
                            <input type="text" className="form-control" name="Name" userinfo='' defaultValue={userInfo?.Name}></input>
                        </div>
                        <div className="form-group col-md-3">
                            <label>نام کاربری</label>
                            <input type="text" className="form-control" name="UserName" userinfo='' defaultValue={userInfo?.UserName}></input>
                        </div>
                        <div className="form-group col-md-3">
                            <label>گذرواژه</label>
                            <input type="password" name="Password" userinfo='' className="form-control"></input>
                        </div>                    
                        <div className="form-group col-md-3">
                            <label>لیست نقش ها</label>
                        <select className="form-control">
                            {roleList && Array.isArray(roleList) && roleList.map((item, i) => <option key={i}>{translateRole(item)}</option>)}
                        </select>
                    </div>
                    <div>
                    <Button className="mt-2 group-Btn" onClick={save}>{!isLoadingSaved && 'ثبت اطلاعات'}{isLoadingSaved && <Loader type="BallTriangle" color="white" height={20} width={20}/>}</Button>
                    </div>
                    </div>

                </div>
            </div>
        </div>)

}
export default UserProfile;